module.exports = __webpack_public_path__ + "media/images/pc/items/album/d18-097cded3b56a5b2350ecc4962013822c.jpg";